import React, { Component } from 'react';
import { connect } from 'react-redux';
import TeamsModal from '../../components/Modals/TeamsModal';
import { MODALS, PERMISSIONS } from '../../constants';
import { checkPermisson, getActiveModal, getLeagues } from '../../selectors/common';
import { getCompetitorsFromState } from '../../selectors/teams';
import LeagueComp from './LeagueComp';
import InfoMessage from '../../components/Modals/InfoMessage';
import { aGetCompetitorsRequest } from '../../reducers';
import { aSetOpenModal } from '../../reducers/common';

const mapToProps = (state) => ({
  activeModal: getActiveModal(state),
  competitors: getCompetitorsFromState(state),
  checkPermisson: (payload) => checkPermisson(state, payload),

  leagues: getLeagues(state),
});

const actionsToProps = (dispatch) => ({
  setOpenModal: (payload) => dispatch(aSetOpenModal(payload)),
  getCompetitors: (payload) => dispatch(aGetCompetitorsRequest(payload)),
});

class Teams extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedLeague: null,
      selectedTeam: null,
      selectedTeamSquadCompleted: false,
    };
  }

  componentDidMount() {
    this.props.getCompetitors();
  }

  handleTeamClick = (leagueId, teamId, squadCompleted) => {
    if (this.props.checkPermisson(PERMISSIONS.GOALSCORER_PLAYERS_VIEW)) {
      const modal = squadCompleted ? MODALS.TEAM_DETAILS : MODALS.INFORMATION_MSG;
      this.props.setOpenModal({
        modal,
      });
      this.setState({
        selectedLeague: leagueId,
        selectedTeam: teamId,
        selectedTeamSquadCompleted: squadCompleted,
      });
    }
  };

  closeModal = () => {
    this.props.setOpenModal({
      modal: '',
    });

    this.setState({
      selectedLeague: null,
      selectedTeam: null,
    });
  };

  getTeamById = (teamId) => this.props.competitors?.find((comp) => comp?.id === teamId);

  /**
   * Render
   *
   * @returns {view}
   */
  render() {
    return (
      <>
        <div className="teams m-t-30">

          {this.props.competitors?.map((league) => (
            <LeagueComp
              key={league?.id}
              league={league}
              handleTeamClick={this.handleTeamClick}
            />

          ))}
        </div>

        {this.props.activeModal === MODALS.TEAM_DETAILS && (
          <TeamsModal
            competitors={this.props.competitors}
            selectedLeague={this.state.selectedLeague}
            selectedTeam={this.state.selectedTeam}
            closeModal={this.closeModal}
            selectedTeamSquadCompleted={this.state.selectedTeamSquadCompleted}
            leagues={this.props.leagues}
          />
        )}
        {this.props.activeModal === MODALS.INFORMATION_MSG && (
          <InfoMessage
            modalData={{
              heading: 'Teams',
              msg: `Players not set for team ${this.getTeamById(this.state.selectedLeague)?.name}`,
            }}
            cancel={this.closeModal}
          />
        )}

      </>
    );
  }
}

export default connect(mapToProps, actionsToProps)(Teams);
